// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"l8-z","subtitle":"m8-z","wrapper":"n8-z","leftArrow":"o8-z","rightArrow":"p8-z"};